
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { useEffect } from "react";
import { LoadingScreen } from "@/components/ui/loading-screen";

const MasterAdminRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const { toast } = useToast();
  
  useEffect(() => {
    if (user && user.role !== "master_admin") {
      toast({
        title: "Access Denied",
        description: "Only master administrators can access this area.",
        variant: "destructive",
      });
    }
  }, [user, toast]);

  if (isLoading) {
    return <LoadingScreen message="Loading master admin portal..." />;
  }

  // If not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  // If not a master admin, redirect to appropriate page
  if (user.role !== "master_admin") {
    if (user.role === "company_super_admin" || user.role === "company_admin") {
      return <Navigate to="/admin" />;
    } else if (user.role === "candidate") {
      return <Navigate to="/candidate" />;
    } else {
      // Fallback for any other roles
      return <Navigate to="/" />;
    }
  }

  // If user is a master admin, render the protected content
  return children;
};

export default MasterAdminRoute;
